import React, { useEffect, useState } from "react";
import InfiniteLooper from "@src/@core/components/MetaDataScroll";
import {
  getTopicPublicity,
  getTopicNews,
} from "@store/action/smartend/TopicAction";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { RefreshCcw } from "react-feather";
import "./pub.scss";

const Publicity = () => {
  const dispatch = useDispatch();
  const NewsReducer = useSelector((state) => state.NewsReducer);
  const pub_publicity = NewsReducer?.publicity?.total;
  const news_publicity = NewsReducer?.news?.total;
  let player_opcaity = document.getElementsByClassName("looper");

  const [toggle, setToggle] = useState(true);
  const handleToggle = () => {
    setToggle(!toggle);
  };
  useEffect(() => {
    dispatch(getTopicPublicity({ per_page: 10 }));
  }, [dispatch, NewsReducer?.publicity?.total]);
  useEffect(() => {
    dispatch(getTopicNews({ per_page: 10 }));
  }, [dispatch, NewsReducer?.news?.total]);
  const { t } = useTranslation();

  return (
    <div>
      <div className="ads_news_switch cursor-pointer" onClick={handleToggle}>
        <span>
          <RefreshCcw />
        </span>
      </div>
      <div
        className="front-pub"
        onMouseEnter={() => {
          player_opcaity[0].style.backgroundColor = "#F9F2ED";
        }}
        onMouseLeave={() => {
          player_opcaity[0].style.backgroundColor = "white";
        }}
      >
        <InfiniteLooper
          direction="left"
          speed={toggle ? news_publicity * 10 : pub_publicity * 10}
        >
          {toggle ? (
            NewsReducer?.news?.data?.length ? (
              NewsReducer?.news?.data?.map((el, i) => (
                <Link
                  to={`/dataNews/News/topics/${el.id}`}
                  className="contentBlock contentBlock--two cursor-pointer"
                  key={i}
                >
                  <img
                    width={30}
                    height={30}
                    style={{ borderRadius: "5px" }}
                    src={el.photo_file}
                    alt={el.photo_file}
                  />
                  <h6 style={{ color: "#000", marginLeft: "5px" }}>
                    {el.title}
                  </h6>
                </Link>
              ))
            ) : (
              <div className="contentBlock contentBlock--two">{t("News")}</div>
            )
          ) : NewsReducer?.publicity?.data?.length ? (
            NewsReducer?.publicity?.data?.map((el, i) => (
              <Link
                to={`/dataNews/Products/topics/${el.id}`}
                className="contentBlock contentBlock--two cursor-pointer"
                key={i}
              >
                <img
                  width={30}
                  height={30}
                  style={{ borderRadius: "5px" }}
                  src={el.photo_file}
                  alt={el.photo_file}
                />
                <h6 style={{ color: "#000", marginLeft: "5px" }}>{el.title}</h6>
              </Link>
            ))
          ) : (
            <div className="contentBlock contentBlock--two">{t("Product")}</div>
          )}
        </InfiniteLooper>
      </div>
      <div className="ads_news">
        <span>{toggle ? t("News") : t("Publicities")}</span>
      </div>
    </div>
  );
};

export default Publicity;
